import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Agent, AgentTokenRefresh } from "@/model";
import agentRepository from "@/repository/agentRepository";
import { agentQueryKeys } from "./keys";


export const useRefreshAgentToken = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Agent, AxiosError, AgentTokenRefresh>({
        mutationKey: ["agent", "refresh-token"],
        mutationFn: async (body: AgentTokenRefresh) => {
            try {
                const { data } = await agentRepository.refreshToken(agentId, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.read(agentId),
                exact: false
            });
        }
    });
};
